import { expFeatureReadV2Api } from "../api.js";
import { TAGS } from "../common.js";
const vnextFeatureReadApi = expFeatureReadV2Api.injectEndpoints({
  endpoints: (builder) => ({
    getProgressionsForFeature: builder.query({
      query: (payload) => {
        return {
          url: `/features/${payload.id}/progressions`,
          body: void 0,
          method: "GET",
          params: { onlyNonArchived: true, onlyArchivedProgressions: false }
        };
      },
      providesTags: (result, error, { id }) => [{ type: TAGS.FEATUREV2, id }]
    })
  })
});
const { usePrefetch: useVnextFeatureReadApiPrefetch, useGetProgressionsForFeatureQuery } = vnextFeatureReadApi;
export {
  useGetProgressionsForFeatureQuery,
  useVnextFeatureReadApiPrefetch,
  vnextFeatureReadApi
};
//# sourceMappingURL=feature-read.js.map
